const generateSrcset = (image, widths = []) => {
  if (!image || !image.src) return "";

  const imageUrl = new URL(image.src, window.location.origin);

  return widths
    .filter((width) => !image.width || width <= image.width)
    .map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(", ");
};

const normalizeText = (value) => {
  return (value || "")
    .toLowerCase()
    .replace(/[_\-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
};

const compactText = (value) => normalizeText(value).replace(/\s+/g, "");

const getMediaText = (media) => {
  return [
    media.alt || "",
    media.src || "",
    media.preview_image?.src || ""
  ].join(" ").toLowerCase();
};

const getColorAliases = (value) => {
  const v = normalizeText(value);
  const c = compactText(value);

  const aliases = [v, c];

  aliases.push(v.replace(/\s+e\s+/g, " "));
  aliases.push(v.replace(/\s+/g, "-"));
  aliases.push(c);

  return [...new Set(aliases)];
};

const scoreMedia = (media, colorValue) => {
  const text = normalizeText(getMediaText(media));
  const compact = compactText(getMediaText(media));
  const aliases = getColorAliases(colorValue);

  let score = 0;

  aliases.forEach((alias) => {
    const cleanAlias = normalizeText(alias);
    const compactAlias = compactText(alias);

    if (text.includes(cleanAlias)) score += 100;
    if (compact.includes(compactAlias)) score += 100;
  });

  if (text.includes("frontale")) score += 8;
  if (text.includes("laterale")) score += 5;
  if (text.includes("lato")) score += 5;

  return score;
};

const updateImage = (img, media) => {
  if (!img || !media) return;

  const preview = media.preview_image || media;
  if (!preview.src) return;

  img.src = preview.src;
  img.srcset = generateSrcset(preview, [
    360, 533, 720, 940, 1066, 1200, 1400, 1600, 1800, 2000
  ]);
  img.alt = media.alt || "";
};

const updateCardImagesByColor = (card, colorValue) => {
  const json = card.querySelector(".product-card-media-json");
  if (!json) return;

  let media = [];

  try {
    media = JSON.parse(json.textContent);
  } catch (e) {
    return;
  }

  if (!media.length) return;

  const scored = media
    .map((item, index) => ({
      item,
      index,
      score: scoreMedia(item, colorValue)
    }))
    .filter((entry) => entry.score > 0)
    .sort((a, b) => b.score - a.score);

  if (!scored.length) return;

  const firstMedia = scored[0].item;
  const secondMedia = scored[1]?.item || scored[0].item;

  const firstImg = card.querySelector(".media--hover-effect img.media--first");
  const secondImg = card.querySelector(".media--hover-effect img.media--second");

  updateImage(firstImg, firstMedia);
  updateImage(secondImg, secondMedia);
};

const checkSwatches = () => {
  document.querySelectorAll(".js-color-swatches-wrapper").forEach((card) => {
    if (card.dataset.swatchesReady === "true") return;
    card.dataset.swatchesReady = "true";

    const swatches = card.querySelectorAll('.js-color-swatches input[type="radio"]');

    swatches.forEach((swatch) => {
      const run = () => {
        const variantLink = swatch.getAttribute("data-variant-link") || "";

        if (variantLink) {
          card.querySelectorAll("a.js-color-swatches-link").forEach((link) => {
            link.href = variantLink;
          });
        }

        updateCardImagesByColor(card, swatch.value);
      };

      swatch.addEventListener("change", run);
      swatch.addEventListener("click", run);
    });
  });
};

function colorSwatches() {
  checkSwatches();

  document.addEventListener("shopify:section:load", function () {
    checkSwatches();
  });
}

(function () {
  colorSwatches();
})();